// extracted by mini-css-extract-plugin
export default {"tableOfContents":"tableOfContents_35-E","docItemContainer":"docItemContainer_gpai"};